import React from "react";
import { Topbar } from "@common";
import { makeStyles } from "@material-ui/core";

type Props = {
  url: string;
};

export const IframeContent = (props: Props) => {
  const classes = useStyles({});
  return (
    <div className={classes.root}>
      <div className={classes.topbar}>
        <Topbar />
      </div>

      <iframe
        src={props.url}
        style={{ border: "none", flex: 1 }}
        width="100%"
        height="100%"
      />
    </div>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    padding: "8px 16px",
    minHeight: "100%"
  },

  topbar: {
    flex: 0,
    marginBottom: 16
  }
}));
